export default class PedidoPrevisaoEntrega {
    id: number;
    pedidoId: number;
    item: number;
    sku: string;
    descricao: string;
    quantidadeCarregada: number;
    dataEntrega: Date;
    dataCarregamento: Date;
    placaCarreta: string;
    placaCavalo: string;
    quantidadeCarregadaReal?: number;
    dataEntregaReal?: Date;
    dataCarregamentoReal?: Date;
    placaCarretaReal?: string;
    placaCavaloReal?: string;
    justificativa?: string;
    quantidadeQuebra?: number;

    constructor(
        id: number,
        pedidoId: number,
        item: number,
        quantidadeCarregada: number,
        dataEntrega: Date,
        dataCarregamento: Date,
        placaCarreta: string,
        placaCavalo: string,
        sku: string,
        descricao: string,
        dataEntregaReal?: Date,
        dataCarregamentoReal?: Date,
        placaCarretaReal?: string,
        placaCavaloReal?: string,
        quantidadeCarregadaReal?: number,
        justificativa?: string,
        quantidadeQuebra?: number
    ){
        this.id = id;
        this.pedidoId = pedidoId;
        this.item = item;
        this.quantidadeCarregada = quantidadeCarregada;
        this.dataEntrega = dataEntrega;
        this.dataCarregamento = dataCarregamento;
        this.placaCarreta = placaCarreta;
        this.placaCavalo = placaCavalo;
        this.sku = sku;
        this.descricao = descricao;
        this.dataEntregaReal = dataEntregaReal;
        this.dataCarregamentoReal = dataCarregamentoReal;
        this.placaCarretaReal = placaCarretaReal;
        this.placaCavaloReal = placaCavaloReal;
        this.quantidadeCarregadaReal = quantidadeCarregadaReal;
        this.justificativa = justificativa;
        this.quantidadeQuebra = quantidadeQuebra;
    }

    static toJson(item: PedidoPrevisaoEntrega): string {
        return JSON.stringify(item);
    }

    static fromJson(json: object[]): PedidoPrevisaoEntrega[] {
        return json.map((item: any) => new PedidoPrevisaoEntrega(
                item["id"],
                item["pedidoId"],
                item["item"],
                item["quantidadeCarregada"],
                new Date(item["dataEntrega"]),
                new Date(item["dataCarregamento"]),
                item["placaCarreta"],
                item["placaCavalo"],
                item["sku"],
                item["descricao"],
                new Date(item["dataEntregaReal"]),
                new Date(item["dataCarregamentoReal"]),
                item["placaCarretaReal"],
                item["placaCavaloReal"],
                item["quantidadeCarregadaReal"],
                item["justificativa"],
                item["quantidadeQuebra"]
            )
        );
    }
}
